import { FC } from 'react';
import { AlertCircle } from 'lucide-react';

interface AvailabilityErrorStateProps {
  message: string;
  onRetry: () => void;
}

export const AvailabilityErrorState: FC<AvailabilityErrorStateProps> = ({ message, onRetry }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-slate-100">Availability</h2>
          <p className="text-gray-600 dark:text-slate-400 mt-1">Set your weekly working hours</p>
        </div>
      </div>
      <div className="bg-red-50 dark:bg-red-900/20 rounded-lg p-8 text-center border border-red-200 dark:border-red-800">
        <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-red-800 dark:text-red-200 mb-2">
          Failed to Load Availability
        </h3>
        <p className="text-red-600 dark:text-red-300 mb-4">{message}</p>
        <button
          onClick={onRetry}
          className="px-6 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};
